import APIv4GetProductByIdResponseAdapter from '../../../Product/Infrastructure/Adapters/APIv4GetProductByIdResponseAdapter';
const APIv4GetFeedProductsResponseAdapter = {
  toProductList: response => {
    const {
      products
    } = response.response_data;
    return products.map(item => {
      return APIv4GetProductByIdResponseAdapter.getProductInfo(item);
    });
  }
};
export default APIv4GetFeedProductsResponseAdapter;
